


































































































































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

import DeviceTree from "@/components/DeviceTree/index.vue";

import { MODULE_COLORS } from "@/utility/Constants";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { CheckTemplateRollsProfileCommand } from "@/model/communication/security/CheckTemplateRollsProfileCommand";
import { CheckTemplateRollsProfileResData } from "@/model/communication/security/CheckTemplateRollsProfileResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import VFaIcon from "@/components/VFaIcon.vue";
import { ImportTemplateCommand, ImportTemplateReqData } from "@/model/communication/security/ImportTemplateCommand";

export default Vue.extend({
    props: { showDialog: Boolean, templateId: Number, templateName: String, loading: Boolean },
    components: {
        DeviceTree,
        VFaIcon,
    },
    data() {
        return {
            moment,
            MODULE_COLORS,
            step: 1,
            templateInstallations: [],
            reload: 0,
            allowedInstallations: [],
            notAllowedInstallations: [],
            loadingCheckVersion: false,
            loadingApplyTemplate: false,
            templateNotApplicable: false,
            startDateTime: null,
            updatedInstallation: null,
            finishedCount: 0,
            commandSent: false,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),

        showForceTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
                this.step = 1;
                this.templateInstallations = [];
                this.reload += 1;
                this.templateNotApplicable = false;
            },
        },
        canContinue() {
            return this.templateInstallations && this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0 && !this.templateNotApplicable;
        },
    },
    methods: {
        continueStep() {
            if (this.step == 1) {
                this.sendRequestCheckRollsProfile();
            } else if (this.step == 2) {
                this.sendRequestApplyTemplate();
            } else if (this.step == 3) {
                this.showForceTemplateDialog = false;
                return;
            }
            this.step += 1;
        },
        backStep() {
            if (this.step == 2) {
                this.templateNotApplicable = false;
            }
            this.step -= 1;
        },
        async sendRequestCheckRollsProfile() {
            this.loadingCheckVersion = true;
            let response: CheckTemplateRollsProfileResData = await new CheckTemplateRollsProfileCommand(
                this.templateId,
                this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((l) => l.name)
            ).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.allowedInstallations = response.allowedInstallations;
                this.notAllowedInstallations = response.notAllowedInstallations;
                if (!this.allowedInstallations || !this.allowedInstallations.length) this.templateNotApplicable = true;
            }
            this.loadingCheckVersion = false;
        },

        async sendRequestApplyTemplate() {
            this.loadingApplyTemplate = true;
            let reqData = new ImportTemplateReqData(this.allowedInstallations, this.templateId);
            let response: ApiGenericResponse = await new ImportTemplateCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.commandSent = true;
            } else this.commandSent = false;
            this.loadingApplyTemplate = false;
        },
        routeToSchedule() {
            let routeData = this.$router.resolve({
                name: "ScheduleConfiguration",
            });
            window.open(routeData.href, "_blank");
        },
    },
});
